import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const SECTORS = ["All", "Technology", "Finance", "Retail", "Manufacturing", "Black Market"];
const SORTS = [
  { value: "value", label: "Value" },
  { value: "unrealizedPnl", label: "P&L" },
  { value: "allocation", label: "Allocation" },
  { value: "ticker", label: "Ticker" },
];

const FilterBar = ({ sector, onSectorChange, sortKey, onSortChange, onExport }) => (
  <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
    <div className="flex items-center gap-2 overflow-x-auto pb-1 sm:pb-0 w-full sm:w-auto">
      <Icon name="Filter" size={14} color="var(--color-muted-foreground)" className="flex-shrink-0" />
      <div className="flex gap-1 flex-shrink-0">
        {SECTORS?.map(s => (
          <button
            key={s}
            onClick={() => onSectorChange(s)}
            className={`px-2.5 py-1 rounded-md font-caption text-xs whitespace-nowrap transition-all duration-200 border flex-shrink-0 ${sector === s ? "border-primary text-primary" : "border-border text-muted-foreground hover:border-primary/40 hover:text-foreground"}`}
            style={sector === s ? { background: "rgba(0,217,255,0.1)" } : { background: "var(--color-muted)" }}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
    <div className="flex items-center gap-2 flex-shrink-0">
      <span className="font-caption text-xs text-muted-foreground whitespace-nowrap">Sort:</span>
      <div className="flex gap-1">
        {SORTS?.map(s => (
          <button
            key={s?.value}
            onClick={() => onSortChange(s?.value)}
            className={`px-2.5 py-1 rounded-md font-caption text-xs transition-all duration-200 border ${sortKey === s?.value ? "border-primary text-primary" : "border-border text-muted-foreground hover:border-primary/40"}`}
            style={sortKey === s?.value ? { background: "rgba(0,217,255,0.1)" } : { background: "var(--color-muted)" }}
          >
            {s?.label}
          </button>
        ))}
      </div>
      <Button variant="outline" size="sm" iconName="Download" iconPosition="left" onClick={onExport}>Export</Button>
    </div>
  </div>
);

export default FilterBar;